import { format } from 'date-fns';
import { apiRequest } from '../../api/client';
import { getApiToken } from '../../api/authToken';

function toDate(dateTime) {
  if (!dateTime) return null;
  if (dateTime instanceof Date) return dateTime;
  if (dateTime?.toDate && typeof dateTime.toDate === 'function') return dateTime.toDate();
  const parsed = new Date(dateTime);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export async function sendShareableLinkEmail({
  companyId,
  companyName,
  toEmail,
  toName,
  serviceName,
  employeeName,
  dateTime,
  shareUrl,
}) {
  const token = await getApiToken();
  const date = toDate(dateTime);
  try {
    return await apiRequest(`/api/companies/${encodeURIComponent(companyId)}/share-link-email`, {
      token,
      method: 'POST',
      body: {
        companyId,
        companyName: companyName || undefined,
        toEmail,
        toName,
        serviceName,
        employeeName,
        dateTimeIso: date ? date.toISOString() : (dateTime && typeof dateTime === 'string' ? dateTime : undefined),
        dateTimeDisplay: date ? `${format(date, 'EEEE, MMMM d, yyyy')} at ${format(date, 'h:mm a')}` : undefined,
        shareUrl,
      },
    });
  } catch (error) {
    const mapped = new Error(error?.message || 'Failed to send email');
    mapped.status = error?.status;
    mapped.body = error?.body;
    mapped.details = error?.body?.details;
    mapped.code = error?.status === 429 ? 'functions/resource-exhausted' : error?.body?.code;
    throw mapped;
  }
}
